import { render } from "./Author.vue?vue&type=template&id=cd3548da"
import script from "./Author.vue?vue&type=script&lang=js"
export * from "./Author.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/Imanyat-Egypt-Systech/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__